import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {LayoutModule} from '../../layout/layout.module';
import {NgxSpinnerModule} from 'ngx-spinner';
import {UIModule} from '../../ui/ui.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SocketIoModule} from 'ngx-socket-io';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyCONST} from '../../CONST/myCONST';
import {UserService} from '../../services/user.service';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {NgxEchartsModule} from 'ngx-echarts';
import {FilterPipe} from '../../services/filter.pipe';
import { MatSelectModule } from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [FilterPipe],
  imports: [
    NgxSpinnerModule,
    LayoutModule,
    UIModule,
    HttpClientModule,
    ReactiveFormsModule,
    SocketIoModule,
    MatSnackBarModule,
    TranslateModule.forChild({}),
    MatButtonModule,
    NgxChartsModule,
    NgxEchartsModule,
    MatInputModule,
    MatMenuModule,
    MatListModule,
    FormsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule
  ],

  exports: [
    NgxSpinnerModule,
    LayoutModule,
    UIModule,
    HttpClientModule,
    ReactiveFormsModule,
    SocketIoModule,
    MatSnackBarModule,
    TranslateModule,
    MatButtonModule,
    NgxChartsModule,
    NgxEchartsModule,
    MatInputModule,
    MatMenuModule,
    MatListModule,
    MatAutocompleteModule,
    FormsModule,
    FilterPipe,
    MatSelectModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule
  ]
})
export class SharedModule {
  constructor(private translate: TranslateService, private  user: UserService) {
    const storedLng = localStorage.getItem(MyCONST.LANG);
    const defaultLng = storedLng ? storedLng : 'fr';
    this.user.defaultLng = defaultLng;
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang(defaultLng);

    this.translate.get('HOME.txt.success_operation_msg').subscribe(res => {
      // console.log('translate result', res);
      this.user.default_msg = res;
    });
  }
}

// #10102d dark mode
